module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi6-be48104f302af69050f6fa72b66b2f9a.jpg";